import palette from './palette';

const theme = {
  palette: {
    ...palette,
    quantifierBorder: palette.grayLight,
    productCard: palette.whiteLight,
    background: palette.white,
    footer: palette.whiteDark,
    foreground: palette.blue,
    priceCard: palette.gray,
    text: palette.grayDark,
  },
};

export default theme;